import react from "react";
function about() {
    return (
        <div className="about-section">
            <div className="about-card">
                <h2 className="about-title">About Me</h2>
                <div className="about-description">
                    <p>A passionate mobile app developer with expertise in creating beautiful, functional applications that deliver exceptional user experiences across Android and iOS platforms.</p>
                    <p>I enjoy crafting delightful mobile UX and smooth micro-interactions.</p>
                    <p>I like turning ideas into shipped features with measurable impact.</p>
                    <p>I value clean code, thoughtful architecture, and performance first.</p>
                    <p>Outside of code: podcasts, design systems, and a good cup of coffee.</p>
                </div>
            </div>
        </div>
    );
}

export default about;